import React from "react";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

const PDF_ICON_PATH = "M128 64C92.7 64 64 92.7 64 128L64 512C64 547.3 92.7 576 128 576L208 576L208 464C208 428.7 236.7 400 272 400L448 400L448 234.5C448 217.5 441.3 201.2 429.3 189.2L322.7 82.7C310.7 70.7 294.5 64 277.5 64L128 64zM389.5 240L296 240C282.7 240 272 229.3 272 216L272 122.5L389.5 240zM272 444C261 444 252 453 252 464L252 592C252 603 261 612 272 612C283 612 292 603 292 592L292 564L304 564C337.1 564 364 537.1 364 504C364 470.9 337.1 444 304 444L272 444zM304 524L292 524L292 484L304 484C315 484 324 493 324 504C324 515 315 524 304 524zM400 444C389 444 380 453 380 464L380 592C380 603 389 612 400 612L432 612C460.7 612 484 588.7 484 560L484 496C484 467.3 460.7 444 432 444L400 444zM420 572L420 484L432 484C438.6 484 444 489.4 444 496L444 560C444 566.6 438.6 572 432 572L420 572zM508 464L508 592C508 603 517 612 528 612C539 612 548 603 548 592L548 548L576 548C587 548 596 539 596 528C596 517 587 508 576 508L548 508L548 484L576 484C587 484 596 475 596 464C596 453 587 444 576 444L528 444C517 444 508 453 508 464z";
const EXTERNAL_LINK_PATH = "M384 96C384 78.3 398.3 64 416 64L544 64C561.7 64 576 78.3 576 96L576 224C576 241.7 561.7 256 544 256C526.3 256 512 241.7 512 224L512 173.3L374.6 310.6C362.1 323.1 341.8 323.1 329.3 310.6C316.8 297.9 316.8 277.8 329.3 265.3L466.7 128L416 128C398.3 128 384 113.7 384 96zM96 160C96 124.7 124.7 96 160 96L288 96C305.7 96 320 110.3 320 128C320 145.7 305.7 160 288 160L160 160L160 480L480 480L480 352C480 334.3 494.3 320 512 320C529.7 320 544 334.3 544 352L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 160z";

const resolveUrl = (filesPath, fileUrl) => {
  if (!fileUrl) return "";
  if (/^(https?:)?\/\//i.test(fileUrl)) return fileUrl;
  return `${`${filesPath || ""}`.replace(/\/+$/, "")}/${`${fileUrl}`.replace(/^\/+/, "")}`;
};

export default function EmergencyProcedureRescueConfigurationMediaSection({ section, sections = {}, sectionNumber = 3 }) {
  const data = section && section.data ? section.data : {};
  const displayName = section && section.display_name
    ? section.display_name
    : "Rescue Configuration Photos & Attachments";
  const filesPath = sections.document_project_details
    && sections.document_project_details.data
    && sections.document_project_details.data.org_details
    ? sections.document_project_details.data.org_details.files_path
    : "";
  const attachments = Array.isArray(data.attachments)
    ? data.attachments.filter((attachment) => attachment && attachment.file_name)
    : [];

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview} ${styles.EmergencyProcedureSectionNum}`}>{sectionNumber}</span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        {attachments.length > 0 ? (
          <div className={styles.emergencyProcedureMediaGrid}>
            {attachments.map((attachment, index) => {
              const file = attachment.file_name && typeof attachment.file_name === "object" ? attachment.file_name : {};
              const fileUrl = typeof attachment.file_name === "string"
                ? attachment.file_name
                : file.file_name || file.file_url || file.url || "";
              const url = resolveUrl(filesPath, fileUrl);
              const isImage = Boolean(file.type && file.type.indexOf("image/") === 0);
              const title = attachment.title || file.visible_name || "Attachment";
              const note = attachment.note || "";

              return (
                <div className={styles.emergencyProcedureMediaCard} key={attachment.id || index}>
                  <a className={styles.emergencyProcedureMediaCardLink} href={url} target="_blank" rel="noopener noreferrer" aria-label={`Open ${title}`}>
                    <svg viewBox="0 0 640 640" aria-hidden="true"><path d={EXTERNAL_LINK_PATH} /></svg>
                  </a>
                  <div className={styles.emergencyProcedureMediaCardPreview}>
                    {isImage ? <img src={url} alt={title} /> : <svg viewBox="0 0 640 640" aria-hidden="true"><path d={PDF_ICON_PATH} /></svg>}
                  </div>
                  <div className={styles.emergencyProcedureMediaCardSeparator} />
                  <div className={styles.emergencyProcedureMediaCardContent}>
                    <div className={styles.emergencyProcedureMediaCardTitle}>{title}</div>
                    <div className={styles.emergencyProcedureMediaCardNote}>{note}</div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className={styles.PreviewPadding}><p /></div>
        )}
      </div>
    </div>
  );
}
